import { Calendar as Fullcalendar } from '@fullcalendar/core';

import BootstrapPlugin from '@fullcalendar/bootstrap';
import DayGridPlugin from '@fullcalendar/daygrid';
import TimeGridPlugin from '@fullcalendar/timegrid';
import ListPlugin from '@fullcalendar/list';
import itLocale from '@fullcalendar/core/locales/it';
import 'jquery-contextmenu/dist/jquery.contextMenu';
import 'jquery-contextmenu/dist/jquery.ui.position';

window.Calendar = (el, options) => {
    return new Fullcalendar(el, {
        themeSystem: 'bootstrap',
        locale: itLocale,
        plugins: [ BootstrapPlugin, DayGridPlugin, TimeGridPlugin, ListPlugin ],
        initialView: 'dayGridMonth',
        // height: 400,
        aspectRatio: 2.5,
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,listWeek'
        },
        ...options
    })
}

// TODO: il seguente codice andrebbe spostato in un file a parte
let fullcalendarEls = document.querySelectorAll('.fullcalendar');
fullcalendarEls.forEach((calendarEl) => {
    let url = calendarEl.dataset.events;

    let calendar = new window.Calendar(calendarEl, {
        events: url,
        eventDidMount: (arg) => {
            $(arg.el).addClass('calendar-event');

            const data = arg.event;

            // console.log(data.title);

            $(arg.el).data({
                'event-title': arg.event.title,
                'event-description': arg.event.extendedProps.description,
                'event-date-id': arg.event.extendedProps.event_date_id,
                'event-date-start': arg.event.extendedProps.event_date_start,
                'event-raw': arg.event.extendedProps.event_raw
            });
        },
        eventContent: (arg, createElement) => {
            // console.log(createElement);
        }
    });

    calendar.render();

    if(!window.Calendar.instances) {
        window.Calendar.instances = {};
    }

    window.Calendar.instances[calendarEl.id] = calendar;
});

$.contextMenu({
    trigger: 'left',
    selector: '.calendar-event',
    items: {
        edit: {
            name: "modifica",
            icon: "fa-edit",
            callback: function(key, opt){
                const title = $(opt.$trigger).data('event-title');
                const description = $(opt.$trigger).data('event-description');
                const event_date_id = $(opt.$trigger).data('event-date-id');
                const old_event = $(opt.$trigger).data('event-raw');
                const start_date = $(opt.$trigger).data('event-date-start');
                
                $('input[name="event_date_id"]', '#modal_edit_calendar').val(event_date_id);

                // console.log(old_event);
                
                // console.log(old_event, opt.$trigger);
                fillEditEventModule(title, description, start_date, old_event);
                $('#modal_edit_calendar').modal('show');
            }
        },
        delete: {
            name: "elimina",
            icon: 'fa-trash',
            callback: function(key, opt){
                const event_date_id = $(opt.$trigger).data('event-date-id');
                
                $('input[name="event_date_id"]', '#modal_remove_calendar').val(event_date_id);
                
                const title = $(opt.$trigger).data('event-title');
                $('.modal-title', '#modal_remove_calendar').html('Rimuovi evento <i>' + title + '</i>');
                $('#modal_remove_calendar').modal('show');
            }
        }
    }
});


function fillEditEventModule(old_title, old_description, start_date, old_event) {
    const $formCalendarEvent = $('#form_edit_calendar');

    // console.log("old_event:", old_event);

    $('#event_title_edit').val(old_title);
    $('#event_description_edit').val(old_description);
    dateStartEditPicker.dates.setValue(new DateTime(start_date));
    // console.log(old_event.date_start);
    
    if (old_event.repeat != 'on') {
        $('#event_repeat_edit').prop('checked', false);
        $('#event_repeat_options_edit').hide();
    } else {
        $('#event_repeat_edit').prop('checked', true);
        // $('#event_repeat_edit_box').show();
        // $('#event_repeat_options_edit').show();
        $('input[name="repeat_number"]', $formCalendarEvent).val(old_event.repeat_number);
        $('select[name="repeat_step"]', $formCalendarEvent).val(old_event.repeat_step);

        switch (old_event.repeat_end_type) {
            case 'date':
                $('input[name="repeat_end_type"][value="date"]', $formCalendarEvent).trigger('click');
                repeatEndDateEditPicker.dates.setValue(new DateTime(old_event.repeat_end_date));
                break;
            case 'count':
                $('input[name="repeat_end_type"][value="count"]', $formCalendarEvent).trigger('click');
                $('input[name="repeat_end_count"]', $formCalendarEvent).val(old_event.repeat_end_count);
                break;
        }
    }

    $('.input-group:first-child', '#event_notify_container_edit').data('index', 0);

    if ($('#event_notify_container_edit').length) {
        old_event.notify_before.forEach((notify, index) => {
            if (index == 0) {
                $('input[name="notify_before[0][number]"]', '#event_notify_container_edit').val(notify.number);
                $('select[name="notify_before[0][step]"]', '#event_notify_container_edit').val(notify.step);
            } else {
                const $inputGroup = $('.input-group:last-child', '#event_notify_container_edit').clone();

                $inputGroup.data('index', index);
                // console.log('new index', index);

                const $inputNumber = $('input[type="number"]', $inputGroup);
                $inputNumber.val(notify.number).attr('name', 'notify_before['+index+'][number]');

                const $inputStep = $('select', $inputGroup);
                $inputStep.val(notify.step).attr('name', 'notify_before['+index+'][step]');

                $('#event_notify_container_edit').append($inputGroup);
            }
        });
    }
}
